import "bootstrap-notify";
import "bootstrap-datepicker";
import "spin.js/spin.css";

import { Storage } from "./storage";
import { SessionTimer } from "./session_timer.js";
import { Translator } from "./translator.js";
import { Menu } from "./menu.js";
import { ModalDialog } from "./modal_dialog";
import { DataTransfer } from "./data_transfer";

export class DataEntry {
  /**
   *
   */
  constructor() {
    this.storage = new Storage();

    const logoutButton = document.querySelector(".logout-button");
    if (logoutButton) {
      logoutButton.addEventListener("click", () => this.storage.clear());
    }

    const data = document.querySelector(".dataentry");
    if (data) {
      this.locale = data.dataset.locale.replace("_", "-");
      this.dateFormat = data.dataset.dateformat;
      this.sessionTimeout = data.dataset.sessionTimeout;
      this.displayPendingCount = data.dataset.displayPendingCount;
      this.access = JSON.parse(data.dataset.access);
    }

    if (this.locale) {
      try {
        require("bootstrap-datepicker-i18n/bootstrap-datepicker." +
          this.locale +
          ".js");
      } catch {
        require("bootstrap-datepicker-i18n/bootstrap-datepicker." +
          this.locale.substring(0, 2) +
          ".js");
      }
    }

    this.translator = new Translator();
    this.menu = new Menu(DataEntry);
    this.modal = new ModalDialog("refresh-session", this);
    this.dataTransfer = new DataTransfer(this);

    if (document.getElementById("releasenote")) {
      this.releasenoteModal = new ModalDialog("releasenote", this);
      const releasenote =
        this.translate("dataentry-releasenote") !== "dataentry-releasenote";
      const releasenoteRead = this.storage.get(
        `releasenote-read-${this.locale}`
      );
      if (releasenote && !releasenoteRead) {
        this.storage.set(`releasenote-read-${this.locale}`, true);
        this.releasenoteModal.show();
      }
    }
  }

  /**
   *
   * @param {*} key
   * @param {*} replacements
   */
  translate(key, replacements) {
    return this.translator.translate(key, replacements);
  }

  /**
   *
   * @param obj
   * @returns {any}
   */
  cloneObject(obj) {
    return JSON.parse(JSON.stringify(obj));
  }

  /**
   *
   * @param el
   */
  createDatePicker(el) {
    let tmpOptions;

    const options = {
      autoclose: true,
      allowInputToggle: true,
      language: this.locale,
      format: this.dateFormat,
      orientation: "bottom",
    };

    if (el.hasClass("datepicker")) {
      el.datepicker(options);
    }

    if (el.hasClass("datepicker-infuture")) {
      tmpOptions = this.cloneObject(options);
      tmpOptions.startDate = "0d";
      el.datepicker(tmpOptions);
    }

    if (el.hasClass("datepicker-inpast")) {
      tmpOptions = this.cloneObject(options);
      tmpOptions.endDate = "0d";
      el.datepicker(tmpOptions);
    }

    el.on("change", () => {
      this.removeError(el);
    });

    // datepicker events conflict within modals (https://github.com/uxsolutions/bootstrap-datepicker/issues/810)
    el.datepicker().on("show.bs.modal", (e) => {
      e.stopPropagation();
    });
    el.datepicker().on("hide.bs.modal", (e) => {
      e.stopPropagation();
    });
  }

  /**
   *
   * @param element
   */
  removeError(element) {
    element.each((index, item) => {
      if (!item || !item.attributes["data-parsley-id"]) {
        return;
      }

      $(item).parents(".parsley-error").removeClass("parsley-error");

      var errorMsg = document.querySelector(
        "#parsley-id-" + item.attributes["data-parsley-id"].nodeValue
      );
      if (errorMsg) {
        $(errorMsg).removeClass("filled");
      }
    });
  }

  /**
   *
   * @param msg
   */
  showLoader(msg) {
    this.pageLoadingFrame("show", "v2", msg);
  }

  /**
   *
   * @param msg
   */
  hideLoader(msg) {
    this.pageLoadingFrame("hide", "v2", msg);
  }

  /**
   *
   * @param {*} action
   * @param {*} ver
   * @param {*} msg
   */
  pageLoadingFrame(action, ver, msg) {
    if (action === "hide") {
      var frame = $(".page-loading-frame");
      if (frame.length > 0) {
        frame.addClass("removed");
        setTimeout(() => {
          frame.remove();
        }, 800);
      }

      return;
    }

    ver = ver ? ver : "v2";

    var pl_frame = $("<div></div>").addClass("page-loading-frame");

    if (ver === "v2") pl_frame.addClass("v2");

    var loader = new Array();
    loader["v1"] =
      '<div class="page-loading-loader"><img src="img/loaders/page-loader.gif"/></div>';

    var v2 = "";
    v2 += '<div class="page-loader-boarder">';
    v2 += '<div class="page-loading-loader">';
    v2 += '<div class="dot1">';
    v2 += "</div>";
    v2 += '<div class="dot2">';
    v2 += "</div>";
    v2 += "</div>";
    v2 += "<span>";

    if (!msg) {
      v2 += "Daten werden geladen";
    } else {
      v2 += msg;
    }

    v2 += "</span>";
    v2 += "</div>";

    loader["v2"] = v2;

    if (action == "show" || !action) {
      $("body").append(pl_frame.html(loader[ver]));
    }
  }

  /**
   *
   * @param type
   * @param msg
   * @param timeout
   */
  showMessage(type, msg, timeout) {
    if (type === "error" && !msg) {
      msg = "A global error occurred";
    }

    $.notify(
      {
        message: msg,
      },
      {
        type: type === "error" ? "danger" : type,
        placement: {
          from: "top",
          align: "right",
        },
        timer: timeout,
      }
    );
  }

  /**
   *
   */
  addSessionTimer() {
    window.session = new SessionTimer({
      lifeTime: this.sessionTimeout,
      selector: ".sessionTimer",
      interval: 1000,
      debug: false,
      sessionRefreshUrl: "/ajax/refreshSession",
      translator: this.translator,
      modal: this.modal,
    });

    window.session.on("sessionUpdate", (seconds) => {
      this.stateToServiceWorker({
        property: "timer",
        value: seconds,
      });
    });
    window.session.on("logout", () => {
      this.storage.clear();
      window.location.replace("/logout");
    });

    // Check that service workers are registered
    if ("serviceWorker" in navigator) {
      // Use the window load event to keep the page load performant
      window.addEventListener("load", () => {
        navigator.serviceWorker
          .register("/service-worker.js")
          .then(() => {
            navigator.serviceWorker.ready;
          })
          .then(() => {
            this.stateToServiceWorker({
              property: "timer",
              value: window.session.getTime(),
            });
            navigator.serviceWorker.addEventListener("message", (event) => {
              if (event.data) {
                var data = event.data;
                if (data.property === "timer" && data.value !== undefined) {
                  window.session.setNewTime(data.value);
                }
              }
            });
          })
          .catch((error) => {
            console.log("Error : ", error);
          });
      });
    }

    const modal = document.getElementById(this.modal.id);
    const el = modal.querySelector(".btn-success");

    el.addEventListener("click", () => {
      window.session.triggerXhrCall();
      this.modal.hide();
    });
  }

  /**
   * Sets the service worker state
   *
   * @param data
   */
  stateToServiceWorker(data) {
    if (navigator.serviceWorker && navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage(data);
    }
  }

  /**
   *
   */
  refreshPendingCount() {
    if (this.displayPendingCount !== "true") {
      return;
    }

    // setTimeout(() => {
    fetch("/ajax/pendingCount")
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data && (data.count === 0 || data.count > 0)) {
          this.pendingCount = data.count;
          this.menu.displayPendingCount(data.count);
        }
      });
    // window.onresize();
    // }, 50);
  }

  /**
   *
   * @param {*} url
   */
  deleteEvent(url) {
    const promise = fetch(url);
    const msg = this.translate("event.delete");

    this.showLoader(msg);
    promise
      .then((response) => response.clone().json())
      .then((data) => {
        if (data.messages) {
          data.messages.forEach((el) => {
            this.showMessage(el.status, el.message);
          });
        }
      })
      .finally(() => this.hideLoader());

    return promise;
  }

  /**
   * displays an event xml preview
   *
   * @param {string} url - preview url to request data
   */
  previewXml(url) {
    this.showLoader();
    const promise = fetch(url);

    promise
      .then((response) => response.clone().json())
      .then((data) => {
        if (!data.xml) {
          this.showMessage("error", this.translate("global.event-not-found"));
        }
      })
      .catch(() =>
        this.showMessage("error", this.translate("global.event-not-found"))
      )
      .finally(() => this.hideLoader());

    return promise;
  }

  /**
   *
   * replaces all quantity form field values notation
   *
   * @param {*} search - the notation to search for
   * @param {*} replace - the notation to replace with
   */
  replaceQuantityFieldsNotation(search = ".", replace = ",") {
    const quantityFields = $('[data-quantity], [name$="[quantity]"]');

    quantityFields.each((i, el) => {
      let quantity = el.value ? el.value : el.innerHTML;
      if (quantity) {
        quantity = quantity.replace(search, replace);
        el.value = quantity;
        el.innerHTML = quantity;
        el.dataset.quantity = quantity;
      }
    });
  }

  /**
   *
   */
  isBrowserIe() {
    return /*@cc_on!@*/ false || !!document.documentMode;
  }
}
